import {
	Checkbox,
	InputLabel,
	ListItemText,
	MenuItem,
	Select,
} from "@mui/material";
import React from "react";
import { LOG_TYPE_CODES } from "../../data/LogTypeCodes";

type Props = {
	LogTypeCode: string[];
	setLogTypeCodeFilter: (logTypeCode: string[]) => void;
};

export const CodeFilter = ({ LogTypeCode, setLogTypeCodeFilter }: Props) => {
	const getDisplayValue = (selected: string[]) => {
		const sorted = [...selected].sort();

		// For 'Info', 'Warning' and 'Error' show 'All'
		if (
			sorted.length === 3 &&
			sorted.includes("I") &&
			sorted.includes("W") &&
			sorted.includes("E")
		) {
			return "All";
		}

		// For 'Info', 'Warning', 'Error' and 'Debug' show 'All + Debug'
		if (
			sorted.length === 4 &&
			sorted.includes("I") &&
			sorted.includes("W") &&
			sorted.includes("E") &&
			sorted.includes("D")
		) {
			return "All + Debug";
		}

		// For others, show the descriptions joined with " + "
		return selected
			.map(
				(code) =>
					LOG_TYPE_CODES[code as keyof typeof LOG_TYPE_CODES]?.description ||
					code,
			)
			.join(" + ");
	};

	return (
		<div
			style={{ marginTop: 6, borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
		>
			<InputLabel
				id="demo-simple-select-label"
				style={{ fontSize: 10, marginBottom: 0 }}
			>
				Type
			</InputLabel>
			<Select
				labelId="code-filter-select-label"
				id="code-filter-select"
				multiple
				value={LogTypeCode}
				onChange={(newLogTypeCode) => {
					const newValue = newLogTypeCode.target.value as string[];
					if (newValue.length > 0) {
						setLogTypeCodeFilter(newValue);
					}
				}}
				variant="standard"
				renderValue={(selected) => getDisplayValue(selected as string[])}
				style={{ minWidth: "100%" }}
			>
				{Object.values(LOG_TYPE_CODES).map((log) => {
					return (
						<MenuItem
							key={`logId-${log.id}`}
							value={log.id}
							style={{ padding: "0px 8px" }}
						>
							<Checkbox
								checked={LogTypeCode.includes(log.id)}
								size="small"
								color="primary"
							/>
							<ListItemText primary={log.description} />
						</MenuItem>
					);
				})}
			</Select>
		</div>
	);
};
